import { Box, CircularProgress } from '@mui/material'

export const GenericSpinner = () => {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
      <CircularProgress color='secondary' />
    </Box>
  )
}